
export const appointments = {
  upcomingAppointments: "Közelgő időpontok",
  pastAppointments: "Korábbi időpontok",
  loading: "Betöltés...",
  noUpcomingAppointments: "Nincsenek közelgő időpontjaid",
  bookNow: "Foglalj most egy időpontot, hogy kapcsolatba léphess a szakértővel",
  goodToKnow: "Jó tudni",
  tips: {
    joinEarly: "A konzultációs időpontokra 5 perccel korábban csatlakozz",
    cancellation: "Konzultáció lemondása legkésőbb 24 órával az időpont előtt lehetséges",
    contact: "Probléma esetén vedd fel a kapcsolatot az ügyfélszolgálattal"
  },
  details: "Részletek",
  joinMeeting: "Csatlakozás a megbeszéléshez",
  topic: "Téma",
  note: "Megjegyzés",
  duration: "perc",
  status: {
    new: "Új",
    accepted: "Elfogadva",
    completed: "Teljesítve",
    rejected: "Elutasítva"
  }
};
